module.exports = __webpack_public_path__ + "img/icono_retry.32b25b31.svg";